<template>
  <span :class="{ 'program-icon-name': programDisplayIcon }">
    <span
      v-if="programDisplayIcon"
      class="material-symbols-outlined"
      :class="{ 'variant-sm': props.variant === 'sm' }"
    >
      {{ programDisplayIcon }}
    </span>
    <span>{{ t(`common_programs.name.${props.programKey}.short_form`) }}</span>
  </span>
</template>
<script lang="ts" setup>
import { ProgramsType } from '@shared/generated';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = withDefaults(
  defineProps<{
    programKey: ProgramsType;
    variant?: 'sm' | 'lg';
  }>(),
  {
    variant: 'lg'
  }
);
const { t } = useI18n();
const programDisplayIcon = computed(() => {
  switch (props.programKey) {
    case ProgramsType.CA_TECH:
      return 'toys_fan';
    case ProgramsType.CA_TECH_WATER_HEATER:
      return 'humidity_high';
    default:
      return null;
  }
});
</script>
<style lang="scss" scoped>
.program-icon-name {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  .material-symbols-outlined {
    font-size: 1rem;
  }
  .material-symbols-outlined.variant-sm {
    font-size: 0.75rem;
  }
}
</style>
